import React, { useState, useEffect } from "react";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import UserServices from "../../../services/UserServices";
import { useDispatch } from "react-redux";
import { updateProfileAction } from "../../../store/actions/AuthActions";

const EditProfileModal = ({
    show,
    handleClose,
    user,
    refreshData
}) => {

    const [formValues, setFormValues] = useState({
        mobileNo: "",
        image: null
    });

    const [preview, setPreview] = useState("");
    const [isCompressing, setIsCompressing] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (user) {
            setFormValues({
                mobileNo: user?.mobileNo || "",
                image: null
            });

            setPreview(
                user?.photo
                    ? `https://indigoinfra.in/img/profileImage/${user.photo}`
                    : ""
            );
        }
    }, [user]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormValues(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleImageChange = async (event) => {

        const files = event.target.files;

        if (!files || files.length === 0) return;

        const file = files[0];

        // Preview first
        const previewURL = URL.createObjectURL(file);
        setPreview(previewURL);

        setIsCompressing(true);

        try {

            const img = new Image();
            img.src = previewURL;

            img.onload = () => {

                const canvas =
                    document.createElement("canvas");

                const MAX_WIDTH = 800;

                const scaleSize =
                    MAX_WIDTH / img.width;

                canvas.width = MAX_WIDTH;

                canvas.height =
                    img.height * scaleSize;

                const ctx =
                    canvas.getContext("2d");

                ctx.drawImage(
                    img,
                    0,
                    0,
                    canvas.width,
                    canvas.height
                );

                canvas.toBlob(
                    (blob) => {

                        setIsCompressing(false);

                        if (!blob) {

                            setFormValues(prev => ({
                                ...prev,
                                image: file
                            }));

                            return;
                        }

                        const compressedFile =
                            new File(
                                [blob],
                                file.name,
                                {
                                    type: "image/jpeg"
                                }
                            );

                        setFormValues(prev => ({
                            ...prev,
                            image: compressedFile
                        }));

                    },
                    "image/jpeg",
                    0.7
                );
            };

            img.onerror = () => {

                setIsCompressing(false);

                setFormValues(prev => ({
                    ...prev,
                    image: file
                }));
            };

        } catch (err) {

            setIsCompressing(false);

            setFormValues(prev => ({
                ...prev,
                image: file
            }));
        }
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            const formData = new FormData();

            formData.append(
                "mobileNo",
                formValues.mobileNo
            );

            if (formValues.image) {
                formData.append(
                    "photo",
                    formValues.image
                );
            }

            const response =
                await UserServices.updateMe(formData);

            console.log(
                "Profile Update Response",
                response.data
            );

            console.log(
                "Updated User",
                response.data.user
            );

            if (response.status === "success") {

                dispatch(
                    updateProfileAction(
                        response.data.user
                    )
                );

                Swal.fire(
                    "Success",
                    "Profile updated successfully",
                    "success"
                );

                handleClose();
            }

        } catch (error) {

            Swal.fire(
                "Error",
                error?.response?.data?.message ||
                "Failed to update profile",
                "error"
            );
        }
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
        >
            <form onSubmit={handleSubmit}>

                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fas fa-user-edit me-2"></i>
                        Edit Profile
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Container>
                        <Row>

                            <Col
                                md={12}
                                className="text-center mb-3"
                            >

                                {preview ? (
                                    <img
                                        src={preview}
                                        alt="profile"
                                        className="rounded-circle border"
                                        style={{
                                            width: "120px",
                                            height: "120px",
                                            objectFit: "cover"
                                        }}
                                    />
                                ) : (
                                    <div
                                        className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mx-auto"
                                        style={{
                                            width: "120px",
                                            height: "120px",
                                            fontSize: "40px",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        {user?.name
                                            ?.charAt(0)
                                            ?.toUpperCase()}
                                    </div>
                                )}

                            </Col>

                            <Col md={12} className="mb-3">

                                <label>
                                    Profile Image
                                </label>

                                <input
                                    type="file"
                                    className="form-control"
                                    accept="image/*"
                                    onClick={(e) =>
                                        (e.target.value = null)
                                    }
                                    onChange={handleImageChange}
                                />

                                {isCompressing && (
                                    <div className="text-center mt-2">
                                        <div
                                            className="spinner-border text-primary"
                                            role="status"
                                        ></div>

                                        <div className="mt-1">
                                            Compressing image...
                                        </div>
                                    </div>
                                )}

                            </Col>

                            <Col md={12}>
                                <label>
                                    Mobile Number
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="mobileNo"
                                    value={formValues.mobileNo}
                                    onChange={handleInputChange}
                                />
                            </Col>

                        </Row>
                    </Container>
                </Modal.Body>

                <Modal.Footer>

                    <Button
                        variant="danger"
                        onClick={handleClose}
                    >
                        Close
                    </Button>

                    <Button
                        variant="primary"
                        type="submit"
                        disabled={isCompressing}
                    >
                        {isCompressing
                            ? "Processing..."
                            : "Save Changes"}
                    </Button>

                </Modal.Footer>

            </form>
        </Modal>
    );
};

export default EditProfileModal;